import React, { useContext, useMemo } from "react";
import { ListItem, ListItemText } from "@material-ui/core";
import clsx from "clsx";
import { Badge, NavLink } from "../../../index";
import Box from "@material-ui/core/Box";
import IntlMessages from "../../../utility/IntlMessages";
import useStyles from "./VerticalItem.style";
import AppContext from "../../../utility/AppContext";
import { checkPermission } from "../../../utility/Utils";
import { NavItemProps } from "../../../../modules/routesConfig";
import AppContextPropsType from "../../../../types/AppContextPropsType";

interface VerticalItemProps {
  item: NavItemProps;
  level: number;
}

const VerticalItem: React.FC<VerticalItemProps> = ({ item, level }) => {
  const { themeMode } = useContext(AppContext);
  const classes = useStyles({ level, themeMode });
  const { user } = useContext<AppContextPropsType>(AppContext);
  const hasPermission = useMemo(() => checkPermission(item.auth, user!.role), [
    item.auth,
    user,
  ]);
  if (!hasPermission) {
    return null;
  }

  return (
    <ListItem
      button
      component={NavLink}
      to={item.url}
      activeClassName="active"
      className={clsx(classes.navItem, "nav-item")}
      exact={item.exact}
    >
      {item.icon && (
        <Box component="span" mr={6}>
          {/* <Icon
            className={clsx(classes.listIcon, 'nav-item-icon')}
            color='action'>
            {item.icon}
          </Icon> */}
          <img
            src={item.icon}
            className={clsx("nav-item-icon", classes.listIcon)}
            alt="menu_icon"
          />
        </Box>
      )}
      <ListItemText
        primary={
          item.count ? (
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{
                minWidth: 20,
                fontWeight: 700,
                fontSize: "0.85rem",
                opacity: 0.8,
              }}>
                {item.count}.
              </span>
              <IntlMessages id={item.messageId} />
            </span>
          ) : (
            <IntlMessages id={item.messageId} />
          )
        }
        classes={{ primary: "nav-item-text" }}
      />
    </ListItem>
  );
};

export default React.memo(VerticalItem);
